import { ArrowRightIcon, Box, ChevronRightIcon, Highlight, HStack, Icon, Stack, Text, useBreakpointValue, useColorModeValue as mode } from '@chaine/keychaine';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
export const SectionDescription = (props) => {
    const { text, highlightedText, link } = props;
    const [isHovered, setIsHovered] = React.useState(false);
    const isMobile = useBreakpointValue({ base: true, md: false });
    const iconContainerStyle = {
        position: 'relative',
        display: 'inline-block',
        alignItems: 'center',
        justifyContent: 'center',
        width: isMobile ? '16px' : '24px',
        height: isMobile ? '16px' : '24px'
    };
    const iconStyle = (isVisible) => ({
        position: 'absolute',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        width: '100%',
        height: '100%'
    });
    return (React.createElement(Box, { maxW: { base: '100%', lg: '80%' } },
        React.createElement(Stack, { spacing: 2, justify: "space-between" },
            React.createElement(Text, { fontSize: { base: 'xl', md: 'xl', lg: '2xl' }, fontWeight: "medium", color: mode('text.secondary', 'text.tertiary') },
                React.createElement(Highlight, { query: highlightedText, styles: { color: 'text.primary', fontWeight: 'bold' } }, text)),
            link && link.visible && (React.createElement(HStack, { spacing: 2, pt: 2 },
                React.createElement(NavLink, { to: link.path, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
                    React.createElement(Text, { _after: {
                            content: '""',
                            position: 'absolute',
                            width: '0',
                            height: '2px',
                            bottom: '0',
                            left: '0',
                            bg: 'currentcolor',
                            transition: 'width .3s ease-in-out'
                        }, _hover: {
                            _after: {
                                width: '100%'
                            }
                        }, color: "text.primary", fontSize: { base: 'lg', md: 'xl', lg: '22px' }, fontWeight: "bold", lineHeight: "tall", position: "relative" }, link.text)),
                React.createElement(Box, { sx: iconContainerStyle },
                    React.createElement(Icon, { as: ChevronRightIcon, color: "icon.primary", sx: iconStyle(!isHovered), boxSize: 5 }),
                    React.createElement(Icon, { as: ArrowRightIcon, color: "icon.primary", sx: iconStyle(isHovered), boxSize: 5 })))))));
};
